import React, { useEffect, useState } from 'react';
import {
    Paper,
    Group,
    Progress,
    Box,
    SimpleGrid,
    RingProgress,
    Center,
    Text
} from '@mantine/core';
import DashboardDataService from '../../../../services/dashboard-activities';
import { BarChart, AreaChart, PieChart } from '@mantine/charts';

import { useMantineTheme } from '@mantine/core';

const itemHeight = 120;

const CustomTooltip = ({ active, payload, label }) => {
    const theme = useMantineTheme();
    if (!active || !payload || payload.length === 0) return null;

    // background adapts to light/dark mode
    const backgroundColor =
        theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white;
    const textColor =
        theme.colorScheme === 'dark' ? theme.colors.gray[0] : theme.black;
    const borderColor =
        theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3];
    const seenNames = new Set();

    return (
      <div
        style={{
          width: 250,            // fixed width
          //maxWidth: 250,         // max width
          backgroundColor,
          border: `1px solid ${borderColor}`,
          borderRadius: 4,
          padding: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          pointerEvents: 'none', // prevents blocking hover interactions
          color: textColor
        }}
      >
        <div style={{ fontWeight: 'bold', marginBottom: 4 }}>{label}</div>
        
        {payload.filter((entry) => {
            if (seenNames.has(entry.name)) return false;
            seenNames.add(entry.name);
            return true;
        }).map((entry, idx) => (
          <div key={idx} style={{ display: 'flex', alignItems: 'center', fontSize: 14, marginBottom: 2 }}>
            <span
                style={{
                display: 'inline-block',
                width: 10,
                height: 10,
                borderRadius: '50%',
                backgroundColor: entry.color,
                marginRight: 6,
                }}
            />
            <span style={{display: "flex", justifyContent: 'space-between', flex: 1}}><span>{entry.name}</span> <span>{entry.value}</span></span>
        </div>
        ))}
      </div>
    );
};

export default function TicketsByHour(props) {
    const [data, setData] = useState([]);

    useEffect(() => {
        if (props.loggedStatus.loggedIn) {
            var date = new Date();
            var currentMonth = "1-12";//date.getMonth() + 1;
            var currentYear = date.getFullYear();
            var currentDay = "1-7";//date.getDay() + 1;
            DashboardDataService.getTicketsByHourOfDay(props.loggedStatus.id, 0, currentDay, currentMonth, currentYear, props.loggedStatus.timezone_adjustment_factor).then(response => {
                console.log(response);
                for (var i = 0; i < response.data.results.length; i++) {
                    response.data.results[i]["Tickets Created"] = response.data.results[i]["created_count"];
                    delete response.data.results[i]["created_count"];
                    response.data.results[i]["Tickets Solved"] = response.data.results[i]["solved_count"];
                    delete response.data.results[i]["solved_count"];
                }
                setData(response.data.results);
            }).catch(e => {
                console.log(e);
            })
        }
    }, []);

    return (
        <Paper withBorder radius="md" h="100%" w="100%" style={{ verticalAlign: "top" }}>
            <Text p="20px">Tickets by Hour <span style={{fontSize: "8pt"}}><i>{`(for the current year)`}</i></span></Text>
            <AreaChart
                h={props.widget.size.y * itemHeight - 90}
                m={0}
                pr="20px"
                data={data}
                dataKey="hour"
                series={[
                    {
                        name: 'Tickets Created',
                        color: 'blue.6',
                    },
                    {
                        name: 'Tickets Solved',
                        color: 'green.6',
                    },
                ]}
                tickLine="y"
                withTooltip
                tooltipProps={{
                    content: <CustomTooltip />,  // use custom tooltip
                    cursor: { stroke: 'rgba(128,128,128,0.6)', strokeWidth: 1 }, // hover line
                }}
            />
        </Paper>
    );
}
